import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locales from './locales';

Vue.use(VueI18n);

const instance = new VueI18n({
  locale: 'en',
  messages: locales,
});

export default instance;
